module.exports = __webpack_public_path__ + "assets/img/951980bd64a449d441049d27b0b75fe1.png";